import { InjectionToken } from '@angular/core';
import { IAuthService } from './auth.interface';

/**
 * Angular injection token for the active auth provider implementation.
 * Resolved in AppModule via `authServiceFactory` based on `environment.authProvider`.
 *
 * Usage in a class constructor:
 *   constructor(@Inject(AUTH_SERVICE) private authService: IAuthService) {}
 */
export const AUTH_SERVICE = new InjectionToken<IAuthService>('AUTH_SERVICE');
